// extracted by mini-css-extract-plugin
export default {"wrapper":"WXr0PD","wrapper--with-copy":"KqtgdD","pre":"QLngrb","copy-button":"nCmerK"};